import api from './api';

export interface TenantFeatureDto {
  featureId: string;
  featureKey: string;
  featureName: string;
  description?: string;
  planType: string;
  enabled: boolean;
}

const extractArrayFromPayload = <T>(payload: unknown, keys: string[]): T[] => {
  if (Array.isArray(payload)) {
    return payload as T[];
  }

  if (!payload || typeof payload !== 'object') {
    return [];
  }

  const asRecord = payload as Record<string, unknown>;
  for (const key of keys) {
    const value = asRecord[key];
    if (Array.isArray(value)) {
      return value as T[];
    }
  }

  const data = asRecord.data;
  if (Array.isArray(data)) {
    return data as T[];
  }

  return [];
};

export const tenantFeaturesService = {
  async getTenantFeatures(tenantId: string): Promise<TenantFeatureDto[]> {
    const response = await api.get(`/tenants/${tenantId}/features`);
    return extractArrayFromPayload<TenantFeatureDto>(response.data, ['features', 'items']);
  },

  async enableFeature(tenantId: string, featureKey: string): Promise<void> {
    await api.post(`/tenants/${tenantId}/features/${featureKey}/enable`);
  },

  async disableFeature(tenantId: string, featureKey: string): Promise<void> {
    await api.post(`/tenants/${tenantId}/features/${featureKey}/disable`);
  },

  async toggleFeature(tenantId: string, featureKey: string): Promise<TenantFeatureDto> {
    const response = await api.post<TenantFeatureDto>(`/tenants/${tenantId}/features/${featureKey}/toggle`);
    return response.data;
  },
};


